import * as React from "react";
import AssetEventSummary from "./AssetEventSummary";
import EventsSecurityLicenseStatus from "./EventsSecurityLicenseStatus";
const AssetEventSummaryContainer = ({ config }) => /* @__PURE__ */ React.createElement(EventsSecurityLicenseStatus, null, /* @__PURE__ */ React.createElement(AssetEventSummary, { config }));
export default AssetEventSummaryContainer;
